/**
 * Guardian Academy Context Store
 *
 * Holds the current academy context when a guardian is viewing
 * academy-scoped routes (/academy/:academySlug/*).
 */

import { create } from 'zustand';
import type { Academy } from '@court-sync/shared';

interface GuardianAcademyState {
  academySlug: string | null;
  academyId: string | null;
  academy: Academy | null;
  setAcademyContext: (slug: string, id: string, academy: Academy) => void;
  clearAcademyContext: () => void;
}

export const useGuardianAcademyStore = create<GuardianAcademyState>((set) => ({
  academySlug: null,
  academyId: null,
  academy: null,
  setAcademyContext: (slug, id, academy) => set({ academySlug: slug, academyId: id, academy }),
  clearAcademyContext: () => set({ academySlug: null, academyId: null, academy: null }),
}));
